import {useCallback, useMemo, useState} from "react";
import {useNavigate} from "react-router-dom";
import {Carousel, CarouselGameCard, HeadingCarousel, normalizeCarouselGame} from "@/components";
import useIsMobile from "@/hooks/useIsMobile";
import {useAuthStore} from "@/store/useAuth.store";
import styles from "./custom-carousels.styles.module.scss";

const CustomCarouselRow = ({carousel}) => {
  const navigate = useNavigate();
  const authStatus = useAuthStore(state => state.authStatus);
  const handleShowAuthModal = useAuthStore(state => state.handleShowAuthModal);
  const mobile = useIsMobile({breakpoint: 426});
  const [carouselApi, setCarouselApi] = useState(null);

  const cardsCount = mobile ? 12 : 16;
  const visibleGames = useMemo(() => (carousel.games ?? []).slice(0, cardsCount), [carousel.games, cardsCount]);

  const handleGameClick = useCallback(
    (provider, gameId) => {
      if (authStatus === "authenticated") {
        navigate(`/games/${provider}/${gameId}`);
      } else {
        handleShowAuthModal();
      }
    },
    [authStatus, navigate, handleShowAuthModal]
  );

  if (!visibleGames.length) {
    return null;
  }

  return (
    <div
      className={styles.recentContainer}
      data-carousel-id={carousel.id}
    >
      <HeadingCarousel
        title={carousel.title}
        subtitle={carousel.subtitle || undefined}
        icon="🎰"
        showArrowsOnMobile
        onPrev={carouselApi?.scrollPrev}
        onNext={carouselApi?.scrollNext}
      />

      <Carousel
        autoScroll={false}
        onInit={setCarouselApi}
        renderItems={() =>
          visibleGames.map((game, idx) => {
            const normalized = normalizeCarouselGame(game);
            return (
              <div key={game.id || `${carousel.id}-${idx}`}>
                <CarouselGameCard
                  name={normalized.name}
                  icon={normalized.icon}
                  providerLabel={normalized.providerLabel}
                  onClick={() => handleGameClick(normalized.provider, normalized.id)}
                />
              </div>
            );
          })
        }
      />
    </div>
  );
};

export default CustomCarouselRow;
